/**
 * Created by Denis Kuzin on 12 august 2024
 */

const ComboComponent = function (cell) {
    this.cell = cell;
};

ComboComponent.prototype.repaint = function () {
    const newColor = this.cell.getRandomColor();
    const params = ComboComponent.CalcConstructor({ color: newColor });
    const Constructor = params.className;
    let newCell = new Constructor(this.cell.x, this.cell.y, {
        components: params.components,
        color: newColor
    });
    newCell.algo = ComboComponent.CalcAlgo(newCell, { random: true });

    const markComponent = newCell.findComponent(MarkComponent);
    if (markComponent) {
        newCell = markComponent.repaint(this.cell);
    }

    return newCell;
};

ComboComponent.prototype.getType = function () {
    return this.cell.algo.name;
};

ComboComponent.prototype.algoEffect = function (callback) {
    if (this.cell.algo.beforeEffect) {
        this.cell.algo.beforeEffect(this.cell);
    }

    const colorComponent = this.cell.findComponent(ColorComponent);
    const color = colorComponent && colorComponent.color || "";

    Game.currentGame.counter.setTimeout(() => {
        if (!Game.currentGame || !Game.currentGame.field) {
            return;
        }

        if (this.cell.algo.findBeforeTargets && this.cell.algo.beforeAction) {
            let targets = this.cell.algo.findBeforeTargets(this.cell);
            targets = targets.filter((target) => !(this.cell.x === target.x && this.cell.y === target.y));
            this.cell.algo.beforeAction(this.cell, targets);
        }

        const choices = this.cell.algo.findTargets(this.cell).filter((choice) => choice !== undefined).map((choice) => ({ x: choice.x, y: choice.y }));

        for (let p = 0; p < choices.length; p++) {
            ComboComponent.addComboTarget(choices[p].x, choices[p].y, color);
        }

        if (this.cell.algo.actionToAllCells) {
            const cells = [];
            for (let i = 0; i < choices.length; i++) {
                ComboComponent.removeComboTarget(choices[i].x, choices[i].y, color);
                const cell = Game.currentGame.field.cells[choices[i].y][choices[i].x];
                if (CombosLibrary.checkFilters(this.cell, cell, true)) {
                    cells.push(cell);
                }
            }
            if (color) {
                cleverapps.effects.fire(`match3.hero_hit.${color}`);
            }
            this.cell.algo.action(this.cell, cells);
        } else {
            let shotIndexTimeout = 0;
            choices.forEach((choice, order) => {
                const flyDuration = this.cell.algo.shootFlyDuration(this.cell, choice);

                const shotFunc = function () {
                    this.cell.algoShotAnimation(choice, flyDuration, order);
                    Game.currentGame.counter.setTimeout(() => {
                        ComboComponent.removeComboTarget(choice.x, choice.y, color);
                        const cell = Game.currentGame.field.cells[choice.y][choice.x];
                        if (CombosLibrary.checkFilters(this.cell, cell, true)) {
                            if (color) {
                                cleverapps.effects.fire(`match3.hero_hit.${color}`);
                            }
                            this.cell.algo.action(this.cell, cell, order);
                        }
                    }, flyDuration * 1000);
                }.bind(this);

                if (shotIndexTimeout > 0) {
                    Game.currentGame.counter.setTimeout(shotFunc, shotIndexTimeout);
                } else {
                    shotFunc();
                }

                shotIndexTimeout += this.cell.algo.between_shoot_timeout;
            });
        }
    }, this.cell.algo.action_delay);

    this.cell.algoEffectAnimation();
    Game.currentGame.counter.setTimeout(() => {
        callback();
    }, this.cell.algo.action_delay + this.cell.algo.action_timeout);

    if (color) {
        cleverapps.eventBus.trigger("taskEvent", "COLLECT_HERO_CELLS", { color });
        cleverapps.eventBus.trigger("activate_hero", { color: color.toLowerCase() });
    }
};

ComboComponent.CalcAlgo = function (base, options) {
    if (Match3Rules.Heroes) {
        const hero = match3.heroes.getHero(base.findComponent(ColorComponent).color, options);
        if (hero.level) {
            return hero;
        }

        return;
    }

    if (options.shape) {
        return CombosLibrary.ByShape[options.shape.calculateForm()];
    }
    if (options.neighbor) {
        if (options.randomDir && (options.neighbor.algo.dir === CombosLibrary.LINER_DIRECTION_HORIZONTAL || options.neighbor.algo.dir === CombosLibrary.LINER_DIRECTION_VERTICAL)) {
            const dir = PseudoRandom.GET().choose([CombosLibrary.LINER_DIRECTION_HORIZONTAL, CombosLibrary.LINER_DIRECTION_VERTICAL]);
            return { ...options.neighbor.algo, dir };
        }
        return options.neighbor.algo;
    }
    if (options.random) {
        return CombosLibrary.ByShape[Shape.PLANE];
    }
    if (options.shapeName) {
        return CombosLibrary.ByShape[options.shapeName];
    }
};

ComboComponent.CalcConstructor = function (base) {
    const colorComponent = base.findComponent && base.findComponent(ColorComponent);
    const color = base.color || colorComponent && colorComponent.color;

    if (Match3Rules.Heroes) {
        if (Game.currentGame && Game.currentGame.goals.hasType(color)) {
            return {
                className: HeroCell,
                components: [GoalCoefComponent]
            };
        }

        return {
            className: HeroCell,
            components: []
        };
    }

    return {
        className: ComboCell,
        components: []
    };
};

ComboComponent.Create = function (base, options) {
    if (options.shape && options.shape.calculateForm() === Shape.FIVE && MultiColorCell.IsAvailable()) {
        return new MultiColorCell(base.x, base.y);
    }

    if (options.shape && options.shape.calculateForm() === Shape.THREE) {
        return;
    }

    const algo = ComboComponent.CalcAlgo(base, options);

    if (!algo) {
        return;
    }

    const params = ComboComponent.CalcConstructor(base, options);
    const ConstructorClass = params.className;

    const baseColorComponent = base.findComponent(ColorComponent);
    const cell = new ConstructorClass(base.x, base.y, {
        components: params.components,
        color: baseColorComponent.color,
        algo
    });

    const baseMarkComponent = base.findComponent(MarkComponent);
    if (baseMarkComponent && baseMarkComponent.mark && !options.shape) {
        const markComponent = cell.findComponent(MarkComponent);
        if (markComponent) {
            markComponent.addMark();
        }
    }

    return cell;
};

ComboComponent.resetComboTargets = function () {
    ComboComponent.targets = {};
};

ComboComponent.comboTargetId = function (x, y, color) {
    return `${x}_${y}_${color}`;
};

ComboComponent.checkComboTarget = function (x, y, color) {
    const uid = ComboComponent.comboTargetId(x, y, color);
    return ComboComponent.targets[uid] && ComboComponent.targets[uid] > 0;
};

ComboComponent.addComboTarget = function (x, y, color) {
    const uid = ComboComponent.comboTargetId(x, y, color);
    if (!ComboComponent.targets[uid]) {
        ComboComponent.targets[uid] = 0;
    }
    ComboComponent.targets[uid]++;
};

ComboComponent.removeComboTarget = function (x, y, color) {
    const uid = ComboComponent.comboTargetId(x, y, color);
    if (ComboComponent.checkComboTarget(x, y, color)) {
        ComboComponent.targets[uid]--;
    }
};